module.exports = __webpack_public_path__ + "img/list.319e7e0a.svg";